// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'table-card';
export const TableCard = withInstall(Index);

export default TableCard;
